import { useEffect, useState } from "react"
import { getDetailFlightTracking } from "services/orderService";

export const useGetDetailFlightTracking = (id) => {
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = async () => {
        setIsLoading(true);
        try {
            const response = await getDetailFlightTracking(id);
            if(response && response?.status === 200){
                setData(response?.data?.data);
            }
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(id){
            getData();
        }
    },[])

    const refresh = () => {
        getData();
    }
    return {data, error, isLoading, refresh}
}